<template>
  <div>
 <!-- v-for="item in galleryItem" -->
    <b-carousel
      id="carousel-1"
      :interval="5000"
      controls
      slide
      background="transparent"
      style="text-shadow: 8px 1px 2px #333;z-index:0"
    >
       <b-carousel-slide class="cBanner" v-for="item in galleryItem">
            <template #img>
            <a v-bind:href="item.href" target="_blank">
                <img class="cBanner"
                v-bind:src= "item.path"
                v-bind:alt="item.path">
              </a>
            </template>
          </b-carousel-slide>

          <b-carousel-slide img-src="../assets/myBijuleeBanner.jpg">
          <div class="store-div"  >
            <a href="https://play.google.com/store/apps/details?id=org.apdcl.apdclportal">
               <img src='../assets/play_store.png' class="store-link">
            </a>

            <a style="padding-left:1rem" href="https://apps.apple.com/in/app/mybijulee/id1402616611">
               <img src='../assets/apple_store.png' class="store-link" >
            </a>
          </div>
        </b-carousel-slide>
        </b-carousel>
      </div>
</template>

<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import axios from 'axios'


export default {

  data() {
      return {
          galleryItem : []

      }

  },
  mounted()
  {

      var temp = [];
      var parent=this;
      this.show=true;
    axios.get(this.$urlCommon+ "/api/web/banner").then(response =>
          {
           console.log(response.data);
            var temp = [];
            this.show=false;
            var data = response.data.bannerList;

            data.forEach(element => {
              temp.push({path:"https://www.apdcl.org/website"+element[0],href:element[1]});
             })
             parent.galleryItem = temp;
            console.log(parent.galleryItem);
        })

      }

}
</script>
<style>
.carousel {
  width:100%;
  box-shadow: 0 4px 8px 0 #00000052, 0 6px 20px 0 #00000069;
   margin-left: 25px; 
}
.cBanner
{
  /* max-height:350px; */
  width:100%;
}
.flex {
 display: flex;
 align-items: right;
 justify-content: center;
}
.carousel-caption
{
  padding:0px !important;
  bottom:10px;
}
.store-link{
  height:3rem;
}
.store-div
{
  text-align:end;

}
@media (max-width: 768px) {
  .store-link{
    height:1.5rem;
  }
  .carousel {
  width:95%;
  box-shadow: 0 4px 8px 0 #00000052, 0 6px 20px 0 #00000069;
   
}


  }
  @media (max-width: 576px) {
    .store-link{
          height:1.2rem;
    }
    .carousel {
  width:95%;
  box-shadow: 0 4px 8px 0 #00000052, 0 6px 20px 0 #00000069;
   
}

    }

</style>
